import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiServiceService } from '../api-service.service';
import { AuthenticationService } from '../authentication.service';
import { GenericResponse } from '../../shared/models/general.modal';
import { MdaDetailsResponse } from '../../shared/models/mda.details';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  readonly BG_PRIMARY_COLOR = "#191615";
  readonly BG_SECONDARY_COLOR = "#1697B4";
  readonly TEXT_PRIMARY_COLOR = "#595A69";
  readonly TEXT_SECONDARY_COLOR = "#FFFFFF";

  private mdaDetails$: BehaviorSubject<MdaDetailsResponse> = new BehaviorSubject(null);

  constructor(
    private readonly apiService: ApiServiceService,
    private readonly authenticationService: AuthenticationService,
  ) {}

  private fetchMdaSettings() {
    this.apiService.get('/mda/details')
    .subscribe({
      next: (response: GenericResponse<MdaDetailsResponse>) => {
        if (response.status !== "success" || !response.data) {
          return;
        }
        const {primaryColor, primaryTextColor, secondaryColor, secondaryTextColor} = response.data;
        this.applyColorScheme(primaryColor, secondaryColor, primaryTextColor, secondaryTextColor);
        this.mdaDetails$.next(response.data);
      }
    })
  }

  private applyColorScheme(primaryColor: string, secondaryColor: string, primaryTextColor: string, secondaryTextColor: string) {
    const documentElement = document.documentElement;
    documentElement.style.setProperty('--color-bg-primary', primaryColor || this.BG_PRIMARY_COLOR);
    documentElement.style.setProperty('--color-bg-secondary', secondaryColor || this.BG_SECONDARY_COLOR);
    documentElement.style.setProperty('--color-text-primary', primaryTextColor || this.TEXT_PRIMARY_COLOR);
    documentElement.style.setProperty('--color-text-secondary', secondaryTextColor || this.TEXT_SECONDARY_COLOR);
  }

  resetColorScheme() {
    const documentElement = document.documentElement;
    documentElement.style.setProperty('--color-bg-primary', this.BG_PRIMARY_COLOR);
    documentElement.style.setProperty('--color-bg-secondary', this.BG_SECONDARY_COLOR);
    documentElement.style.setProperty('--color-text-primary', this.TEXT_PRIMARY_COLOR);
    documentElement.style.setProperty('--color-text-secondary', this.TEXT_SECONDARY_COLOR);
  }

  get mdaDetails() {
    return this.mdaDetails$.asObservable(); 
  }

  resolveApplicationColorScheme() {
    if (this.authenticationService.isAuthenticated()) this.fetchMdaSettings();
  }
}
